import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({ ...props }) => {
  return (
    <Sonner
      theme="dark"
      className="toaster group"
      position="top-right"
      mobileOffset={{ top: "calc(env(safe-area-inset-top, 0px) + 76px)" }}
      richColors={false}
      closeButton
      toastOptions={{
        unstyled: false,
        classNames: {
          toast: "group toast luxury-toast",
          title: "font-display",
          description: "text-xs",
          actionButton: "luxury-toast-action",
          cancelButton: "luxury-toast-cancel",
        },
      }}
      {...props}
    />
  );
}

export { Toaster, toast }
